async function createGeneratedRouteFactory(app, routeDef, routeName, moduleLoader, modelLoader) {
    const { default: fallbackModuleClass, ...moduleExports } = await moduleLoader();
    const { default: fallbackModelClass, ...modelExports } = await modelLoader();
    const authManager = app.authManager;
    if (!authManager)
        throw new Error(`Application is missing "authManager" required for generated route "${routeName}".`);

    const ModuleClass = fallbackModuleClass || Object.values(moduleExports)[0];
    const ModelClass = fallbackModelClass || Object.values(modelExports)[0];
    const dataModel = ModelClass.getInstance(authManager);
    await dataModel.prepare();

    return new ModuleClass(null, {
        ...routeDef.options,
        dataModel,
    });
}

export const generatedRoutes = [
    {
        name: 'default-core-setting-browser',
        path: '/default/core/setting',
        privileges: [["adminSystem"]],
        options: {
            "entityName": "core.Setting",
            "name": "default-core-setting-browser",
            "moduleName": "default-core-setting-browser",
            "moduleTitle": "Nastavení",
            "moduleStateSlotName": "default-core-setting-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-setting-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/SettingModel.js'),
        ),
    },
    {
        name: 'default-core-setting-editor',
        path: '/default/core/setting/:id',
        privileges: [["adminSystem"]],
        options: {
            "entityName": "core.Setting",
            "name": "default-core-setting-editor",
            "moduleName": "default-core-setting-editor",
            "moduleTitle": "Nastavení",
            "moduleStateSlotName": "default-core-setting-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-setting-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/SettingModel.js'),
        ),
    },
    {
        name: 'default-core-timezone-browser',
        path: '/default/core/timezone',
        privileges: [["adminSystem"]],
        options: {
            "entityName": "core.TimeZone",
            "name": "default-core-timezone-browser",
            "moduleName": "default-core-timezone-browser",
            "moduleTitle": "Časové zóny",
            "moduleStateSlotName": "default-core-timezone-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-timezone-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/TimeZoneModel.js'),
        ),
    },
    {
        name: 'default-core-timezone-editor',
        path: '/default/core/timezone/:id',
        privileges: [["adminSystem"]],
        options: {
            "entityName": "core.TimeZone",
            "name": "default-core-timezone-editor",
            "moduleName": "default-core-timezone-editor",
            "moduleTitle": "Časová zóna",
            "moduleStateSlotName": "default-core-timezone-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-timezone-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/TimeZoneModel.js'),
        ),
    },
    {
        name: 'default-core-user-browser',
        path: '/default/core/user',
        privileges: [["manageUsers"],["adminUsers"]],
        options: {
            "entityName": "core.User",
            "name": "default-core-user-browser",
            "moduleName": "default-core-user-browser",
            "moduleTitle": "Uživatelé",
            "moduleStateSlotName": "default-core-user-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-user-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/UserModel.js'),
        ),
    },
    {
        name: 'default-core-user-editor',
        path: '/default/core/user/:id',
        privileges: [["manageUsers"],["adminUsers"]],
        options: {
            "entityName": "core.User",
            "name": "default-core-user-editor",
            "moduleName": "default-core-user-editor",
            "moduleTitle": "Uživatel",
            "moduleStateSlotName": "default-core-user-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-user-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/UserModel.js'),
        ),
    },
    {
        name: 'default-core-privilege-browser',
        path: '/default/core/privilege',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.Privilege",
            "name": "default-core-privilege-browser",
            "moduleName": "default-core-privilege-browser",
            "moduleTitle": "Oprávnění",
            "moduleStateSlotName": "default-core-privilege-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-privilege-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/PrivilegeModel.js'),
        ),
    },
    {
        name: 'default-core-privilege-editor',
        path: '/default/core/privilege/:id',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.Privilege",
            "name": "default-core-privilege-editor",
            "moduleName": "default-core-privilege-editor",
            "moduleTitle": "Oprávnění",
            "moduleStateSlotName": "default-core-privilege-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-privilege-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/PrivilegeModel.js'),
        ),
    },
    {
        name: 'default-core-role-browser',
        path: '/default/core/role',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.Role",
            "name": "default-core-role-browser",
            "moduleName": "default-core-role-browser",
            "moduleTitle": "Role",
            "moduleStateSlotName": "default-core-role-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-role-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/RoleModel.js'),
        ),
    },
    {
        name: 'default-core-role-editor',
        path: '/default/core/role/:id',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.Role",
            "name": "default-core-role-editor",
            "moduleName": "default-core-role-editor",
            "moduleTitle": "Role",
            "moduleStateSlotName": "default-core-role-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-role-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/RoleModel.js'),
        ),
    },
    {
        name: 'default-core-roleprivilege-browser',
        path: '/default/core/roleprivilege',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.RolePrivilege",
            "name": "default-core-roleprivilege-browser",
            "moduleName": "default-core-roleprivilege-browser",
            "moduleTitle": "Oprávnění role",
            "moduleStateSlotName": "default-core-roleprivilege-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-roleprivilege-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/RolePrivilegeModel.js'),
        ),
    },
    {
        name: 'default-core-roleprivilege-editor',
        path: '/default/core/roleprivilege/:id',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.RolePrivilege",
            "name": "default-core-roleprivilege-editor",
            "moduleName": "default-core-roleprivilege-editor",
            "moduleTitle": "Oprávnění role",
            "moduleStateSlotName": "default-core-roleprivilege-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-roleprivilege-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/RolePrivilegeModel.js'),
        ),
    },
    {
        name: 'default-core-userrole-browser',
        path: '/default/core/userrole',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.UserRole",
            "name": "default-core-userrole-browser",
            "moduleName": "default-core-userrole-browser",
            "moduleTitle": "Role uživatele",
            "moduleStateSlotName": "default-core-userrole-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-userrole-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/UserRoleModel.js'),
        ),
    },
    {
        name: 'default-core-userrole-editor',
        path: '/default/core/userrole/:id',
        privileges: [["adminUsers"]],
        options: {
            "entityName": "core.UserRole",
            "name": "default-core-userrole-editor",
            "moduleName": "default-core-userrole-editor",
            "moduleTitle": "Role uživatele",
            "moduleStateSlotName": "default-core-userrole-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-userrole-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/UserRoleModel.js'),
        ),
    },
    {
        name: 'default-core-permission-browser',
        path: '/default/core/permission',
        privileges: null,
        options: {
            "entityName": "core.Permission",
            "name": "default-core-permission-browser",
            "moduleName": "default-core-permission-browser",
            "moduleTitle": "Přístupová oprávnění",
            "moduleStateSlotName": "default-core-permission-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-permission-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/PermissionModel.js'),
        ),
    },
    {
        name: 'default-core-permission-editor',
        path: '/default/core/permission/:id',
        privileges: null,
        options: {
            "entityName": "core.Permission",
            "name": "default-core-permission-editor",
            "moduleName": "default-core-permission-editor",
            "moduleTitle": "Přístupové oprávnění",
            "moduleStateSlotName": "default-core-permission-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-permission-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/PermissionModel.js'),
        ),
    },
    {
        name: 'default-core-foldertype-browser',
        path: '/default/core/foldertype',
        privileges: null,
        options: {
            "entityName": "core.FolderType",
            "name": "default-core-foldertype-browser",
            "moduleName": "default-core-foldertype-browser",
            "moduleTitle": "Typy složek",
            "moduleStateSlotName": "default-core-foldertype-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-foldertype-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/FolderTypeModel.js'),
        ),
    },
    {
        name: 'default-core-foldertype-editor',
        path: '/default/core/foldertype/:id',
        privileges: null,
        options: {
            "entityName": "core.FolderType",
            "name": "default-core-foldertype-editor",
            "moduleName": "default-core-foldertype-editor",
            "moduleTitle": "Typ složky",
            "moduleStateSlotName": "default-core-foldertype-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-foldertype-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/FolderTypeModel.js'),
        ),
    },
    {
        name: 'default-core-folder-browser',
        path: '/default/core/folder',
        privileges: [["useFileRepository"]],
        options: {
            "entityName": "core.Folder",
            "name": "default-core-folder-browser",
            "moduleName": "default-core-folder-browser",
            "moduleTitle": "Složky",
            "moduleStateSlotName": "default-core-folder-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-folder-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/FolderModel.js'),
        ),
    },
    {
        name: 'default-core-folder-editor',
        path: '/default/core/folder/:id',
        privileges: [["useFileRepository"]],
        options: {
            "entityName": "core.Folder",
            "name": "default-core-folder-editor",
            "moduleName": "default-core-folder-editor",
            "moduleTitle": "Složka",
            "moduleStateSlotName": "default-core-folder-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-folder-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/FolderModel.js'),
        ),
    },
    {
        name: 'default-core-folderpermission-browser',
        path: '/default/core/folderpermission',
        privileges: [["adminFileRepository"]],
        options: {
            "entityName": "core.FolderPermission",
            "name": "default-core-folderpermission-browser",
            "moduleName": "default-core-folderpermission-browser",
            "moduleTitle": "Přístupová práva složek",
            "moduleStateSlotName": "default-core-folderpermission-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-folderpermission-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/FolderPermissionModel.js'),
        ),
    },
    {
        name: 'default-core-folderpermission-editor',
        path: '/default/core/folderpermission/:id',
        privileges: [["adminFileRepository"]],
        options: {
            "entityName": "core.FolderPermission",
            "name": "default-core-folderpermission-editor",
            "moduleName": "default-core-folderpermission-editor",
            "moduleTitle": "Přístupové právo složky",
            "moduleStateSlotName": "default-core-folderpermission-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-folderpermission-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/FolderPermissionModel.js'),
        ),
    },
    {
        name: 'default-core-filetype-browser',
        path: '/default/core/filetype',
        privileges: null,
        options: {
            "entityName": "core.FileType",
            "name": "default-core-filetype-browser",
            "moduleName": "default-core-filetype-browser",
            "moduleTitle": "Typy souborů",
            "moduleStateSlotName": "default-core-filetype-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-filetype-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/FileTypeModel.js'),
        ),
    },
    {
        name: 'default-core-filetype-editor',
        path: '/default/core/filetype/:id',
        privileges: null,
        options: {
            "entityName": "core.FileType",
            "name": "default-core-filetype-editor",
            "moduleName": "default-core-filetype-editor",
            "moduleTitle": "Typ souboru",
            "moduleStateSlotName": "default-core-filetype-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-filetype-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/FileTypeModel.js'),
        ),
    },
    {
        name: 'default-core-file-browser',
        path: '/default/core/file',
        privileges: [["useFileRepository"]],
        options: {
            "entityName": "core.File",
            "name": "default-core-file-browser",
            "moduleName": "default-core-file-browser",
            "moduleTitle": "Soubory",
            "moduleStateSlotName": "default-core-file-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-file-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/FileModel.js'),
        ),
    },
    {
        name: 'default-core-file-editor',
        path: '/default/core/file/:id',
        privileges: [["useFileRepository"]],
        options: {
            "entityName": "core.File",
            "name": "default-core-file-editor",
            "moduleName": "default-core-file-editor",
            "moduleTitle": "Soubor",
            "moduleStateSlotName": "default-core-file-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-file-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/FileModel.js'),
        ),
    },
    {
        name: 'default-core-workflow-browser',
        path: '/default/core/workflow',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.Workflow",
            "name": "default-core-workflow-browser",
            "moduleName": "default-core-workflow-browser",
            "moduleTitle": "Workflow",
            "moduleStateSlotName": "default-core-workflow-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflow-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/WorkflowModel.js'),
        ),
    },
    {
        name: 'default-core-workflow-editor',
        path: '/default/core/workflow/:id',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.Workflow",
            "name": "default-core-workflow-editor",
            "moduleName": "default-core-workflow-editor",
            "moduleTitle": "Workflow",
            "moduleStateSlotName": "default-core-workflow-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflow-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/WorkflowModel.js'),
        ),
    },
    {
        name: 'default-core-workflowstatus-browser',
        path: '/default/core/workflowstatus',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.WorkflowStatus",
            "name": "default-core-workflowstatus-browser",
            "moduleName": "default-core-workflowstatus-browser",
            "moduleTitle": "Stavy workflow",
            "moduleStateSlotName": "default-core-workflowstatus-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflowstatus-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/WorkflowStatusModel.js'),
        ),
    },
    {
        name: 'default-core-workflowstatus-editor',
        path: '/default/core/workflowstatus/:id',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.WorkflowStatus",
            "name": "default-core-workflowstatus-editor",
            "moduleName": "default-core-workflowstatus-editor",
            "moduleTitle": "Stav workflow",
            "moduleStateSlotName": "default-core-workflowstatus-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflowstatus-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/WorkflowStatusModel.js'),
        ),
    },
    {
        name: 'default-core-workflowtransition-browser',
        path: '/default/core/workflowtransition',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.WorkflowTransition",
            "name": "default-core-workflowtransition-browser",
            "moduleName": "default-core-workflowtransition-browser",
            "moduleTitle": "Přechody workflow",
            "moduleStateSlotName": "default-core-workflowtransition-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflowtransition-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/WorkflowTransitionModel.js'),
        ),
    },
    {
        name: 'default-core-workflowtransition-editor',
        path: '/default/core/workflowtransition/:id',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.WorkflowTransition",
            "name": "default-core-workflowtransition-editor",
            "moduleName": "default-core-workflowtransition-editor",
            "moduleTitle": "Přechod workflow",
            "moduleStateSlotName": "default-core-workflowtransition-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflowtransition-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/WorkflowTransitionModel.js'),
        ),
    },
    {
        name: 'default-core-workflowtransitionprivilege-browser',
        path: '/default/core/workflowtransitionprivilege',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.WorkflowTransitionPrivilege",
            "name": "default-core-workflowtransitionprivilege-browser",
            "moduleName": "default-core-workflowtransitionprivilege-browser",
            "moduleTitle": "Oprávnění přechodů workflow",
            "moduleStateSlotName": "default-core-workflowtransitionprivilege-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflowtransitionprivilege-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/core/models/WorkflowTransitionPrivilegeModel.js'),
        ),
    },
    {
        name: 'default-core-workflowtransitionprivilege-editor',
        path: '/default/core/workflowtransitionprivilege/:id',
        privileges: [["adminWorkflow"]],
        options: {
            "entityName": "core.WorkflowTransitionPrivilege",
            "name": "default-core-workflowtransitionprivilege-editor",
            "moduleName": "default-core-workflowtransitionprivilege-editor",
            "moduleTitle": "Oprávnění přechodu workflow",
            "moduleStateSlotName": "default-core-workflowtransitionprivilege-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-core-workflowtransitionprivilege-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/core/models/WorkflowTransitionPrivilegeModel.js'),
        ),
    },
    {
        name: 'default-customers-person-browser',
        path: '/default/customers/person',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.Person",
            "name": "default-customers-person-browser",
            "moduleName": "default-customers-person-browser",
            "moduleTitle": "Osoby",
            "moduleStateSlotName": "default-customers-person-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-person-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/customers/models/PersonModel.js'),
        ),
    },
    {
        name: 'default-customers-person-editor',
        path: '/default/customers/person/:id',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.Person",
            "name": "default-customers-person-editor",
            "moduleName": "default-customers-person-editor",
            "moduleTitle": "Osoba",
            "moduleStateSlotName": "default-customers-person-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-person-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/customers/models/PersonModel.js'),
        ),
    },
    {
        name: 'default-customers-address-browser',
        path: '/default/customers/address',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.Address",
            "name": "default-customers-address-browser",
            "moduleName": "default-customers-address-browser",
            "moduleTitle": "Adresy",
            "moduleStateSlotName": "default-customers-address-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-address-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/customers/models/AddressModel.js'),
        ),
    },
    {
        name: 'default-customers-address-editor',
        path: '/default/customers/address/:id',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.Address",
            "name": "default-customers-address-editor",
            "moduleName": "default-customers-address-editor",
            "moduleTitle": "Adresa",
            "moduleStateSlotName": "default-customers-address-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-address-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/customers/models/AddressModel.js'),
        ),
    },
    {
        name: 'default-customers-customer-browser',
        path: '/default/customers/customer',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.Customer",
            "name": "default-customers-customer-browser",
            "moduleName": "default-customers-customer-browser",
            "moduleTitle": "Zákazníci",
            "moduleStateSlotName": "default-customers-customer-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-customer-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/customers/models/CustomerModel.js'),
        ),
    },
    {
        name: 'default-customers-customer-editor',
        path: '/default/customers/customer/:id',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.Customer",
            "name": "default-customers-customer-editor",
            "moduleName": "default-customers-customer-editor",
            "moduleTitle": "Zákazník",
            "moduleStateSlotName": "default-customers-customer-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-customer-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/customers/models/CustomerModel.js'),
        ),
    },
    {
        name: 'default-customers-customerperson-browser',
        path: '/default/customers/customerperson',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.CustomerPerson",
            "name": "default-customers-customerperson-browser",
            "moduleName": "default-customers-customerperson-browser",
            "moduleTitle": "Osoby zákazníka",
            "moduleStateSlotName": "default-customers-customerperson-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-customerperson-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/customers/models/CustomerPersonModel.js'),
        ),
    },
    {
        name: 'default-customers-customerperson-editor',
        path: '/default/customers/customerperson/:id',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.CustomerPerson",
            "name": "default-customers-customerperson-editor",
            "moduleName": "default-customers-customerperson-editor",
            "moduleTitle": "Osoba zákazníka",
            "moduleStateSlotName": "default-customers-customerperson-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-customerperson-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/customers/models/CustomerPersonModel.js'),
        ),
    },
    {
        name: 'default-customers-customeraddress-browser',
        path: '/default/customers/customeraddress',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.CustomerAddress",
            "name": "default-customers-customeraddress-browser",
            "moduleName": "default-customers-customeraddress-browser",
            "moduleTitle": "Adresa zákazníka",
            "moduleStateSlotName": "default-customers-customeraddress-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-customeraddress-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/customers/models/CustomerAddressModel.js'),
        ),
    },
    {
        name: 'default-customers-customeraddress-editor',
        path: '/default/customers/customeraddress/:id',
        privileges: [["manageCustomers"],["adminCustomers"]],
        options: {
            "entityName": "customers.CustomerAddress",
            "name": "default-customers-customeraddress-editor",
            "moduleName": "default-customers-customeraddress-editor",
            "moduleTitle": "Adresa zákazníka",
            "moduleStateSlotName": "default-customers-customeraddress-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-customers-customeraddress-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/customers/models/CustomerAddressModel.js'),
        ),
    },
    {
        name: 'default-employees-employee-browser',
        path: '/default/employees/employee',
        privileges: [["manageEmployees"],["adminEmployees"]],
        options: {
            "entityName": "employees.Employee",
            "name": "default-employees-employee-browser",
            "moduleName": "default-employees-employee-browser",
            "moduleTitle": "Zaměstnanci",
            "moduleStateSlotName": "default-employees-employee-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-employees-employee-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/employees/models/EmployeeModel.js'),
        ),
    },
    {
        name: 'default-employees-employee-editor',
        path: '/default/employees/employee/:id',
        privileges: [["manageEmployees"],["adminEmployees"]],
        options: {
            "entityName": "employees.Employee",
            "name": "default-employees-employee-editor",
            "moduleName": "default-employees-employee-editor",
            "moduleTitle": "Zaměstnanec",
            "moduleStateSlotName": "default-employees-employee-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-employees-employee-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/employees/models/EmployeeModel.js'),
        ),
    },
    {
        name: 'default-machines-enginefueltype-browser',
        path: '/default/machines/enginefueltype',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.EngineFuelType",
            "name": "default-machines-enginefueltype-browser",
            "moduleName": "default-machines-enginefueltype-browser",
            "moduleTitle": "Typy paliv",
            "moduleStateSlotName": "default-machines-enginefueltype-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-enginefueltype-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/machines/models/EngineFuelTypeModel.js'),
        ),
    },
    {
        name: 'default-machines-enginefueltype-editor',
        path: '/default/machines/enginefueltype/:id',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.EngineFuelType",
            "name": "default-machines-enginefueltype-editor",
            "moduleName": "default-machines-enginefueltype-editor",
            "moduleTitle": "Typ paliva",
            "moduleStateSlotName": "default-machines-enginefueltype-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-enginefueltype-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/machines/models/EngineFuelTypeModel.js'),
        ),
    },
    {
        name: 'default-machines-enginetype-browser',
        path: '/default/machines/enginetype',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.EngineType",
            "name": "default-machines-enginetype-browser",
            "moduleName": "default-machines-enginetype-browser",
            "moduleTitle": "Typy strojů",
            "moduleStateSlotName": "default-machines-enginetype-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-enginetype-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/machines/models/EngineTypeModel.js'),
        ),
    },
    {
        name: 'default-machines-enginetype-editor',
        path: '/default/machines/enginetype/:id',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.EngineType",
            "name": "default-machines-enginetype-editor",
            "moduleName": "default-machines-enginetype-editor",
            "moduleTitle": "Typ stroje",
            "moduleStateSlotName": "default-machines-enginetype-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-enginetype-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/machines/models/EngineTypeModel.js'),
        ),
    },
    {
        name: 'default-machines-generatortype-browser',
        path: '/default/machines/generatortype',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.GeneratorType",
            "name": "default-machines-generatortype-browser",
            "moduleName": "default-machines-generatortype-browser",
            "moduleTitle": "Typy generátorů",
            "moduleStateSlotName": "default-machines-generatortype-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-generatortype-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/machines/models/GeneratorTypeModel.js'),
        ),
    },
    {
        name: 'default-machines-generatortype-editor',
        path: '/default/machines/generatortype/:id',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.GeneratorType",
            "name": "default-machines-generatortype-editor",
            "moduleName": "default-machines-generatortype-editor",
            "moduleTitle": "Typ generátoru",
            "moduleStateSlotName": "default-machines-generatortype-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-generatortype-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/machines/models/GeneratorTypeModel.js'),
        ),
    },
    {
        name: 'default-machines-machinestatus-browser',
        path: '/default/machines/machinestatus',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.MachineStatus",
            "name": "default-machines-machinestatus-browser",
            "moduleName": "default-machines-machinestatus-browser",
            "moduleTitle": "Stavy strojů",
            "moduleStateSlotName": "default-machines-machinestatus-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-machinestatus-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/machines/models/MachineStatusModel.js'),
        ),
    },
    {
        name: 'default-machines-machinestatus-editor',
        path: '/default/machines/machinestatus/:id',
        privileges: [["adminMachines"]],
        options: {
            "entityName": "machines.MachineStatus",
            "name": "default-machines-machinestatus-editor",
            "moduleName": "default-machines-machinestatus-editor",
            "moduleTitle": "Stav stroje",
            "moduleStateSlotName": "default-machines-machinestatus-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-machinestatus-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/machines/models/MachineStatusModel.js'),
        ),
    },
    {
        name: 'default-machines-machine-browser',
        path: '/default/machines/machine',
        privileges: [["manageMachines"],["adminMachines"]],
        options: {
            "entityName": "machines.Machine",
            "name": "default-machines-machine-browser",
            "moduleName": "default-machines-machine-browser",
            "moduleTitle": "Stroje",
            "moduleStateSlotName": "default-machines-machine-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-machine-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/machines/models/MachineModel.js'),
        ),
    },
    {
        name: 'default-machines-machine-editor',
        path: '/default/machines/machine/:id',
        privileges: [["manageMachines"],["adminMachines"]],
        options: {
            "entityName": "machines.Machine",
            "name": "default-machines-machine-editor",
            "moduleName": "default-machines-machine-editor",
            "moduleTitle": "Stroj",
            "moduleStateSlotName": "default-machines-machine-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-machines-machine-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/machines/models/MachineModel.js'),
        ),
    },
    {
        name: 'default-work-workholiday-browser',
        path: '/default/work/workholiday',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkHoliday",
            "name": "default-work-workholiday-browser",
            "moduleName": "default-work-workholiday-browser",
            "moduleTitle": "Státní svátky",
            "moduleStateSlotName": "default-work-workholiday-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workholiday-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkHolidayModel.js'),
        ),
    },
    {
        name: 'default-work-workholiday-editor',
        path: '/default/work/workholiday/:id',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkHoliday",
            "name": "default-work-workholiday-editor",
            "moduleName": "default-work-workholiday-editor",
            "moduleTitle": "Státní svátek",
            "moduleStateSlotName": "default-work-workholiday-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workholiday-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkHolidayModel.js'),
        ),
    },
    {
        name: 'default-work-workgroup-browser',
        path: '/default/work/workgroup',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkGroup",
            "name": "default-work-workgroup-browser",
            "moduleName": "default-work-workgroup-browser",
            "moduleTitle": "Skupiny prací",
            "moduleStateSlotName": "default-work-workgroup-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workgroup-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkGroupModel.js'),
        ),
    },
    {
        name: 'default-work-workgroup-editor',
        path: '/default/work/workgroup/:id',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkGroup",
            "name": "default-work-workgroup-editor",
            "moduleName": "default-work-workgroup-editor",
            "moduleTitle": "Skupina práce",
            "moduleStateSlotName": "default-work-workgroup-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workgroup-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkGroupModel.js'),
        ),
    },
    {
        name: 'default-work-workactivity-browser',
        path: '/default/work/workactivity',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkActivity",
            "name": "default-work-workactivity-browser",
            "moduleName": "default-work-workactivity-browser",
            "moduleTitle": "Pracovní aktivity",
            "moduleStateSlotName": "default-work-workactivity-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workactivity-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkActivityModel.js'),
        ),
    },
    {
        name: 'default-work-workactivity-editor',
        path: '/default/work/workactivity/:id',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkActivity",
            "name": "default-work-workactivity-editor",
            "moduleName": "default-work-workactivity-editor",
            "moduleTitle": "Pracovní aktivita",
            "moduleStateSlotName": "default-work-workactivity-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workactivity-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkActivityModel.js'),
        ),
    },
    {
        name: 'default-work-worktype-browser',
        path: '/default/work/worktype',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkType",
            "name": "default-work-worktype-browser",
            "moduleName": "default-work-worktype-browser",
            "moduleTitle": "Typy prací",
            "moduleStateSlotName": "default-work-worktype-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-worktype-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkTypeModel.js'),
        ),
    },
    {
        name: 'default-work-worktype-editor',
        path: '/default/work/worktype/:id',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkType",
            "name": "default-work-worktype-editor",
            "moduleName": "default-work-worktype-editor",
            "moduleTitle": "Typ práce",
            "moduleStateSlotName": "default-work-worktype-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-worktype-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkTypeModel.js'),
        ),
    },
    {
        name: 'default-work-workactivityaction-browser',
        path: '/default/work/workactivityaction',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkActivityAction",
            "name": "default-work-workactivityaction-browser",
            "moduleName": "default-work-workactivityaction-browser",
            "moduleTitle": "Akce k typům aktivit",
            "moduleStateSlotName": "default-work-workactivityaction-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workactivityaction-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkActivityActionModel.js'),
        ),
    },
    {
        name: 'default-work-workactivityaction-editor',
        path: '/default/work/workactivityaction/:id',
        privileges: [["adminWork"]],
        options: {
            "entityName": "work.WorkActivityAction",
            "name": "default-work-workactivityaction-editor",
            "moduleName": "default-work-workactivityaction-editor",
            "moduleTitle": "Akce k typu aktivity",
            "moduleStateSlotName": "default-work-workactivityaction-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workactivityaction-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkActivityActionModel.js'),
        ),
    },
    {
        name: 'default-work-workcontract-browser',
        path: '/default/work/workcontract',
        privileges: [["manageWork"],["adminWork"]],
        options: {
            "entityName": "work.WorkContract",
            "name": "default-work-workcontract-browser",
            "moduleName": "default-work-workcontract-browser",
            "moduleTitle": "Zakázky",
            "moduleStateSlotName": "default-work-workcontract-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workcontract-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkContractModel.js'),
        ),
    },
    {
        name: 'default-work-workcontract-editor',
        path: '/default/work/workcontract/:id',
        privileges: [["manageWork"],["adminWork"]],
        options: {
            "entityName": "work.WorkContract",
            "name": "default-work-workcontract-editor",
            "moduleName": "default-work-workcontract-editor",
            "moduleTitle": "Zakázka",
            "moduleStateSlotName": "default-work-workcontract-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workcontract-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkContractModel.js'),
        ),
    },
    {
        name: 'default-work-workschedule-browser',
        path: '/default/work/workschedule',
        privileges: [["editWork"],["manageWork"],["adminWork"]],
        options: {
            "entityName": "work.WorkSchedule",
            "name": "default-work-workschedule-browser",
            "moduleName": "default-work-workschedule-browser",
            "moduleTitle": "Rozpisy prací",
            "moduleStateSlotName": "default-work-workschedule-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workschedule-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkScheduleModel.js'),
        ),
    },
    {
        name: 'default-work-workschedule-editor',
        path: '/default/work/workschedule/:id',
        privileges: [["editWork"],["manageWork"],["adminWork"]],
        options: {
            "entityName": "work.WorkSchedule",
            "name": "default-work-workschedule-editor",
            "moduleName": "default-work-workschedule-editor",
            "moduleTitle": "Rozpis práce",
            "moduleStateSlotName": "default-work-workschedule-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workschedule-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkScheduleModel.js'),
        ),
    },
    {
        name: 'default-work-workevent-browser',
        path: '/default/work/workevent',
        privileges: [["manageWork"],["adminWork"]],
        options: {
            "entityName": "work.WorkEvent",
            "name": "default-work-workevent-browser",
            "moduleName": "default-work-workevent-browser",
            "moduleTitle": "Pracovní události",
            "moduleStateSlotName": "default-work-workevent-browser"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workevent-browser',
            () => import('../lib/ui/modules/DataBrowser.js'),
            () => import('./modules/work/models/WorkEventModel.js'),
        ),
    },
    {
        name: 'default-work-workevent-editor',
        path: '/default/work/workevent/:id',
        privileges: [["manageWork"],["adminWork"]],
        options: {
            "entityName": "work.WorkEvent",
            "name": "default-work-workevent-editor",
            "moduleName": "default-work-workevent-editor",
            "moduleTitle": "Pracovní události",
            "moduleStateSlotName": "default-work-workevent-editor"
        },
        factory: async (app, routeDef, routeMatch) => createGeneratedRouteFactory(
            app,
            routeDef,
            'default-work-workevent-editor',
            () => import('../lib/ui/modules/DataEditor.js'),
            () => import('./modules/work/models/WorkEventModel.js'),
        ),
    },
];
